import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { pdfStyles } from './pdfStyles';
import {
  getSupplierItemCustomerTotal,
  getSupplierItemInternalTotal,
} from '../../utils/pdfHelpers';

const money = (value) => `${Number(value || 0).toLocaleString('da-DK')} DKK`;

export default function OfferPDFTotals({ supplierSections = [], variant = 'internal' }) {
  const items = supplierSections.flatMap((section) => section.items || []);
  const internalTotal = items.reduce((sum, item) => sum + getSupplierItemInternalTotal(item), 0);
  const customerTotal = items.reduce((sum, item) => sum + getSupplierItemCustomerTotal(item), 0);

  if (variant === 'supplier') {
    return (
      <View style={pdfStyles.totals}>
        <View style={[pdfStyles.totalRow, pdfStyles.totalFinal, { borderBottomWidth: 0 }]}>
          <Text>Total</Text>
          <Text>{money(internalTotal)}</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={pdfStyles.totals}>
      {variant === 'internal' && (
        <View style={pdfStyles.totalRow}>
          <Text>Internal total</Text>
          <Text>{money(internalTotal)}</Text>
        </View>
      )}
      <View style={[pdfStyles.totalRow, pdfStyles.totalFinal, { borderBottomWidth: 0 }]}>
        <Text>{variant === 'customer' ? 'Total' : 'Customer total'}</Text>
        <Text>{money(customerTotal)}</Text>
      </View>
    </View>
  );
}
